import React from "react";
import { useDispatch, useSelector } from "react-redux";
import {
  postLikeChange,
  postSaveChange,
  savePostToggled,
  updatePostLike,
} from "../../features/post/postSlice";

export default function DetailedPost({ post }) {
  const dispatch = useDispatch();
  const { id, image, title, tags, likes, isSaved, description } = useSelector((state) => state.post.post);

  const handleSave = (e) => {
    e.preventDefault();
    dispatch(savePostToggled({ isSaved, id }));
    dispatch(postSaveChange());
  };

  const handleLike = (e) => {
    e.preventDefault();
    dispatch(updatePostLike({ likes, id }));
    dispatch(postLikeChange());
  };

  return (
    <main className="post">
      <img
        src={image}
        alt="githum"
        className="w-full rounded-md"
        id="lws-megaThumb"
      />
      <div>
        <h1 className="mt-6 text-2xl post-title" id="lws-singleTitle">
          {title}
        </h1>
        <div className="tags" id="lws-singleTags">
          {tags.map((tag, index) => {
            const comma = index < tags.length - 1 ? ", " : "";
            return (
              <span key={index}>
                #{tag}
                {comma}
              </span>
            );
          })}
        </div>
        <div className="btn-group">
          {/* <!-- handle like on button click --> */}
          <button
            className="like-btn"
            id="lws-singleLinks"
            onClick={handleLike}
          >
            <i className="fa-regular fa-thumbs-up"></i> {likes}
          </button>
          {/* <!-- handle save on button click --> */}
          {/* <!-- use ".active" class and "Saved" text  if a post is saved, other wise "Save" --> */}
          <button
            className={`${isSaved ? "active" : ""} save-btn`}
            id="lws-singleSavedBtn"
            onClick={handleSave}
          >
            <i className="fa-regular fa-bookmark"></i>{" "}
            {isSaved ? "Saved" : "Save"}
          </button>
        </div>
        <div className="mt-6">
          <p>{description}</p>
        </div>
      </div>
    </main>
  );
}
